module.exports = __webpack_public_path__ + "static/media/JP_VS_EYELASHES01.292df036.jpg";